import { defaultColumns, defaultSort } from '../../components/data/products/manufacturers/columns';

export default {
  state: {
    manufacturers: [],
    loading: false,
    tableConfig: null,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    manufacturers: state => state.manufacturers,
    loading: state => state.loading,
    tableConfig: state => state.tableConfig,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setManufacturers(state, manufacturers) {
      state.manufacturers = manufacturers;
    },
    setLoading(state, display) {
      state.loading = display;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
  },
  actions: {

    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/manufacturer-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'manufacturer-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'manufacturer-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAllWithPagination({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const manufacturers = await axios.get('api/manufacturers' + (query || ''));
        commit('setManufacturers', manufacturers);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const manufacturers = await axios.get('api/manufacturers-all');
        commit('setManufacturers', manufacturers);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/manufacturers/' + id);
      } catch (e) {
      }
    },

    async create({ commit }, payLoad) {
      try {
        await axios.post('api/manufacturers', payLoad);
      } catch (e) {
      }
    },

    async update({ commit }, payLoad) {
      try {
        await axios.put('api/manufacturers', payLoad);
      } catch (e) {
      }
    },

    async delete({}, id) {
      await axios.delete('api/manufacturers/' + id);
    }
  },
};
